import * as React from 'react';
import { DateTimeInput } from '../../../components/form-elements/DateTimeInput';
import { LocalTimeRead } from '../../../models/utilities/local-time-read';
import { GlobalConstants } from '../../../utils/app-constants';
import { EndShipmentAction } from '../../models/shipments/shipment-action';

interface IProps {
    destination : EndShipmentAction;    
    isQuickCreate: boolean;
    updateTruck: any;
}

export const ShipmentEditDestination = (props : IProps) => {

    const [editDestination, setEditDestination]  = React.useState<EndShipmentAction>(new EndShipmentAction());
    
    /**
     * Hydrate the required properties for editing
     */
    React.useEffect(() => {
        if (props.destination) {
            setEditDestination({...props.destination});
        }
    }, [props.destination]);

    /**
     * Handler for changing the shipment date.
     * @param newDate The new shipment date as chosen 
     */
    const onCutoffDateChange = (newDate: Date) => {         
        const t = {...editDestination};

        if (!t.actionTime) {
            t.actionTime = new LocalTimeRead();
        }

        t.actionTime.local = newDate;
        setEditDestination(t);

        if (props.isQuickCreate) {
            props.updateTruck(t, props.destination.tmpClientId);
        }
    };

    return <div className="stop-action-edit-delivery">
                                      
                <div className="row">
                    <div className="col-md-6">
                        <DateTimeInput
                            id="pickupTime"
                            format={ GlobalConstants.ABBR_LONG_DATE }
                            value={ editDestination.actionTime ? editDestination.actionTime.local : undefined }
                            showTimezone={ true }
                            timezone={ editDestination.address.timeZoneId }
                            label="Return Time"
                            onChange={ onCutoffDateChange }
                        />
                    </div>
                </div>
                          
    </div>;

};
